module.exports = __webpack_public_path__ + "static/media/jose_jaetis_rosario.48c817d8.jpg";